import { Printer } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { OrderConfirmationDoc } from "@/components/OrderConfirmationDoc";
import { fdate, label } from "@/lib/api";

function Brand({ title, code }) {
  return (
    <div className="flex items-start justify-between border-b border-zinc-300 pb-4 mb-5">
      <div><div className="font-display text-xl font-bold">GAMERZ NATION</div><div className="text-xs text-zinc-500">Custom PC Manufacturing · GSTIN 27AAKCG1234F1Z5</div></div>
      <div className="text-right"><div className="text-sm font-semibold uppercase tracking-wider">{title}</div><div className="font-mono text-xs">{code}</div></div>
    </div>
  );
}

function Receipt({ p }) {
  return <div data-testid="order-receipt"><OrderConfirmationDoc p={p} /></div>;
}

function JobSheet({ p }) {
  return (
    <div className="print-area bg-white text-zinc-900 rounded-md p-6 text-sm" data-testid="job-sheet">
      <Brand title="Workshop Job Sheet" code={p.projectCode} />
      <div className="grid grid-cols-3 gap-4 mb-5 text-xs">
        <div><div className="text-zinc-500">Customer</div><div className="font-medium text-sm">{p.customerName}</div></div>
        <div><div className="text-zinc-500">Workflow</div><div className="font-medium text-sm">{p.workflowName}</div></div>
        <div><div className="text-zinc-500">Created</div><div className="font-medium text-sm">{fdate(p.createdAt)}</div></div>
      </div>
      <table className="w-full text-xs border border-zinc-300">
        <thead><tr className="bg-zinc-100"><th className="text-left p-2">Category</th><th className="text-left p-2">Part</th><th className="text-left p-2">Stock</th><th className="text-left p-2 w-48">Serial Number</th></tr></thead>
        <tbody>{p.parts.map((x) => (
          <tr key={x.id} className="border-t border-zinc-300"><td className="p-2">{label(x.category)}</td><td className="p-2">{x.customPartName}</td>
            <td className="p-2">{x.inStock ? "In Stock" : "To Procure"}</td><td className="p-2 font-mono">{x.serialNumber || "______________________"}</td></tr>
        ))}</tbody>
      </table>
      <div className="grid grid-cols-3 gap-6 mt-10 text-xs">{["Technician", "QA Tester", "Dispatch"].map((r) => <div key={r} className="border-t border-zinc-400 pt-1.5">{r} signature</div>)}</div>
    </div>
  );
}

export function ProjectDocsDialog({ project, open, onClose, initial = "receipt" }) {
  if (!project) return null;
  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="max-w-3xl max-h-[90vh] overflow-y-auto" data-testid="project-docs-dialog">
        <DialogHeader className="no-print"><DialogTitle>Project {project.projectCode} documents</DialogTitle></DialogHeader>
        <Tabs defaultValue={initial}>
          <div className="flex items-center justify-between no-print">
            <TabsList><TabsTrigger value="receipt" data-testid="docs-tab-receipt">Order Receipt</TabsTrigger><TabsTrigger value="jobsheet" data-testid="docs-tab-jobsheet">Job Sheet</TabsTrigger></TabsList>
            <Button size="sm" onClick={() => window.print()} data-testid="print-doc-button"><Printer className="h-4 w-4 mr-2" />Print</Button>
          </div>
          <TabsContent value="receipt"><Receipt p={project} /></TabsContent>
          <TabsContent value="jobsheet"><JobSheet p={project} /></TabsContent>
        </Tabs>
      </DialogContent>
    </Dialog>
  );
}
